export const GAME_VIEW = {
    MAIN: 'main',
    BONUS: 'bonus'
};

export const GAME_TYPE = {
    DEFAULT: 'default',
    BONUS_1: 'bonus_1',
    BONUS_2: 'bonus_2'
};

export const POPUP_AUTO_PROCEED_TIME = 30000;
